import { apiSlice } from "../../api/apiSlice";

export const compareModelsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompareDefaultCarsConfig: builder.query({
      query: () => "/api/v1/admin/compare-models/default-cars",
    }),
    updateCompareDefaultCarsConfig: builder.mutation({
      query: (data) => ({
        url: "/api/v1/admin/compare-models/default-cars",
        method: "PUT",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetCompareDefaultCarsConfigQuery,
  useUpdateCompareDefaultCarsConfigMutation,
} = compareModelsApiSlice;
